module.exports = __webpack_public_path__ + "img/white-logo-en-express.a87023a.png";